import {
  friendlyProgressDetails,
  friendlyProgressSummary,
  friendlyProgressTraceText,
} from './progressLabelVocabulary.js'

export function firstActiveRun(runs) {
  return Array.isArray(runs)
    ? runs.find((run) => run?.status === 'running' || run?.status === 'queued')
    : null
}

export function progressFromRun(run) {
  const events = Array.isArray(run?.progressEvents) ? run.progressEvents : []
  const details = friendlyProgressDetails(events, 40)
  const eventIds = events
    .map((event) => event?.eventId || `${event?.type || 'event'}:${event?.status || ''}:${event?.traceText || ''}`)
    .filter(Boolean)
  return {
    summary: friendlyProgressSummary(run),
    details,
    eventIds,
  }
}

export function dedupeStrings(values) {
  const seen = new Set()
  return values.filter((value) => {
    const text = typeof value === 'string' ? value.trim() : ''
    if (!text || seen.has(text)) return false
    seen.add(text)
    return true
  })
}

export function traceTextFromProgressEvent(event) {
  if (!event || typeof event !== 'object') return ''
  return friendlyProgressTraceText(event)
}
